<template>
    <div class="p-3">
        <h3>RL 3.6 Kegiatan Pelayanan Kebidanan</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Kegiatan Pelayanan Kebidanan" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'year',
                    label: 'Tahun',
                    field: 'year',
                    type: 'year',
                    colClass: 'col-sm-3',
                    component: 'DropDownYear'
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-kebidanan',
                layout: 'fitDataStretch',
                columnMinWidth: 80,
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        width: 70,
                        hozAlign: "center",
                        frozen: true,
                    },
                    {
                        title: "Jenis Kegiatan",
                        field: "jenisKegiatan",
                        width: 250,
                        frozen: true,
                    },
                    {
                        title: "Rujukan Medis",
                        columns: [
                            {
                                title: "Rumah Sakit",
                                field: "rujukan_medis_rumahsakit",
                                hozAlign: "center",
                            },
                            {
                                title: "Bidan",
                                field: "rujukan_medis_bidan",
                                hozAlign: "center",
                            },
                            {
                                title: "Puskesmas",
                                field: "rujukan_medis_puskesmas",
                                hozAlign: "center",
                            },
                            {
                                title: "Fas Kes Lainnya",
                                field: "rujukan_medis_faskes",
                                hozAlign: "center",
                            },
                            {
                                title: "Jumlah Hidup",
                                field: "rujukan_medis_jumlahhidup",
                                width: 90,
                                hozAlign: "center",
                                editor: "number",
                                editorParams: { min: 0 }
                            },
                            {
                                title: "Jumlah Mati",
                                field: "rujukan_medis_jumlahmati",
                                hozAlign: "center",
                                editor: "number",
                                editorParams: { min: 0 }
                            },
                            {
                                title: "Total",
                                field: "rujukan_medis_jumlahtotal",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Rujukan Non Medis",
                        columns: [
                            {
                                title: "Jumlah Hidup",
                                field: "rujukan_nonmedis_jumlahhidup",
                                hozAlign: "center",
                            },
                            {
                                title: "Jumlah Mati",
                                field: "rujukan_nonmedis_jumlahmati",
                                hozAlign: "center",
                            },
                            {
                                title: "Total",
                                field: "rujukan_nonmedis_jumlahtotal",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Non Rujukan",
                        columns: [
                            {
                                title: "Jumlah Hidup",
                                field: "nonrujukan_jumlahhidup",
                                hozAlign: "center",
                            },
                            {
                                title: "Jumlah Mati",
                                field: "nonrujukan_jumlahmati",
                                hozAlign: "center",
                            },
                            {
                                title: "Total",
                                field: "nonrujukan_jumlahtotal",
                                hozAlign: "center",
                            }
                        ]
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
